module.exports = __webpack_public_path__ + "media/cards/13-c65eef1d.png";